import axios, {AxiosResponse} from "axios";

export const getPermissions = async(pattern?: string) => {
    const params = pattern ? {pattern: pattern} : {}
    return await axios
        .get(route("api.user.permissions", params))
        .then((response: AxiosResponse<string[]>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}

export const setUserMetadataValue = async(key: string, value: any) => {
    return await axios
        .post(route("api.user.set-metadata-value"), {key: key, value: value})
        .then((response: AxiosResponse<any>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}
